(() => {
  const PINK = '#D186A1';
  const DARK = '#300D1A';
  const GOLD = '#BFA46F';
  const WHITE = '#FFFFFF';
  const TARGETS = new Set(['Remembrance', 'Celebration']);

  const normalize = (value) => (value || '').replace(/\s+/g, ' ').trim();

  function linkedInput(el) {
    if (el instanceof HTMLLabelElement && el.htmlFor) {
      const input = document.getElementById(el.htmlFor);
      if (input) return input;
    }
    return el.querySelector?.('input[type="radio"], input[type="checkbox"]') || null;
  }

  function isSelected(el) {
    const input = linkedInput(el);
    if (input?.checked) return true;

    if (
      el.getAttribute('aria-pressed') === 'true' ||
      el.getAttribute('aria-selected') === 'true' ||
      el.getAttribute('data-selected') === 'true'
    ) return true;

    const chain = [el, el.parentElement, el.parentElement?.parentElement].filter(Boolean);
    return chain.some((node) => {
      const cls = typeof node.className === 'string' ? node.className : '';
      return /(^|\s)(selected|active|checked|is-selected|is-active)(\s|$)/i.test(cls);
    });
  }

  function applyStyles() {
    const root = document.querySelector('.gpo-app') || document;
    const candidates = root.querySelectorAll('label, button, [role="button"]');

    candidates.forEach((el) => {
      const label = normalize(el.textContent);
      if (!TARGETS.has(label)) return;

      const selected = isSelected(el);

      el.style.setProperty('background-color', selected ? PINK : WHITE, 'important');
      el.style.setProperty('color', selected ? WHITE : DARK, 'important');
      el.style.setProperty('border-color', selected ? PINK : GOLD, 'important');

      if (!el.dataset.toujoursPinkBound) {
        el.dataset.toujoursPinkBound = 'true';

        el.addEventListener('mouseenter', () => {
          if (!isSelected(el)) {
            el.style.setProperty('color', PINK, 'important');
          }
        });

        el.addEventListener('mouseleave', () => {
          applyStyles();
        });

        el.addEventListener('click', () => {
          requestAnimationFrame(applyStyles);
          setTimeout(applyStyles, 50);
          setTimeout(applyStyles, 200);
        });
      }
    });
  }

  document.addEventListener('change', applyStyles, true);
  document.addEventListener('DOMContentLoaded', applyStyles);
  window.addEventListener('load', applyStyles);

  const observer = new MutationObserver(applyStyles);
  observer.observe(document.documentElement, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ['class', 'checked', 'aria-pressed', 'aria-selected', 'data-selected']
  });

  applyStyles();
})();